import { ApiMethod, FormApiMethod } from '../../types/types';

const RESERVED_API_METHOD_KEYS = new Set([
  'default',
  'get',
  'insert',
  'update',
]);

// Extracts the handler-only entries from form.apiMethods by dropping the
// reserved keys (default, get, insert, update) that belong to the form
// lifecycle rather than to user-defined handlers.
export const getHandlerApiMethods = (
  apiMethods: FormApiMethod | undefined
): Record<string, ApiMethod> => {
  if (!apiMethods) return {};

  const entries: Array<[string, ApiMethod]> = [];

  Object.entries(apiMethods as Record<string, unknown>).forEach(
    ([key, value]) => {
      if (RESERVED_API_METHOD_KEYS.has(key)) return;
      if (value === undefined || value === null) return;
      if (typeof value !== 'string' && typeof value !== 'object') return;

      entries.push([key, value as ApiMethod]);
    }
  );

  return Object.fromEntries(entries);
};
